var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14.286,
    viewBox: "0 0 10 14.286",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M2.524 7.193a.714.714 0 1 1 .524 1.329A2.556 2.556 0 0 0 1.429 10.9v1.243a.714.714 0 0 0 .714.714h5.714a.714.714 0 0 0 .714-.714v-1.177a2.613 2.613 0 0 0-1.683-2.442A.714.714 0 1 1 7.4 7.19a4.041 4.041 0 0 1 2.6 3.776v1.176a2.143 2.143 0 0 1-2.143 2.143H2.143A2.143 2.143 0 0 1 0 12.143V10.9a3.985 3.985 0 0 1 2.524-3.707zM5 0a2.857 2.857 0 0 1 2.857 2.857v1.429a2.857 2.857 0 0 1-5.714 0V2.857A2.857 2.857 0 0 1 5 0zm0 1.429a1.429 1.429 0 0 0-1.429 1.428v1.429a1.429 1.429 0 0 0 2.857 0V2.857A1.429 1.429 0 0 0 5 1.429z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.df45369aa91543da29540c6602906d02.svg";